import { LeadFormHero } from "./lead-form-hero"
import type { HeroShellProps } from "./hero-types"

export type EmailCaptureHeroProps = HeroShellProps

export function EmailCaptureHero(props: EmailCaptureHeroProps) {
  return <LeadFormHero {...props} form={props.form ?? { fields: [{ name: "email", label: "Email", type: "email", placeholder: "you@example.com", required: true }], submitLabel: "Join waitlist", successMessage: "You are on the waitlist." }} />
}
